import { api } from "@/lib/api";

function base64ToBytes(value) {
  const pad = "=".repeat((4 - (value.length % 4)) % 4);
  const raw = atob((value + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}

export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window))
    return { status: "unsupported" };
  if (Notification.permission === "denied") return { status: "denied" };
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return { status: "denied" };
    const reg = await navigator.serviceWorker.register("/service-worker.js");
    await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/vapid-public-key");
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: base64ToBytes(data.publicKey),
      });
    }
    await api.post("/push/subscribe", { subscription: sub.toJSON() });
    return { status: "enabled" };
  } catch (e) {
    console.error(e);
    return { status: "unavailable" };
  }
}

export function pushStatus() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission; // default | granted | denied
}
